var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.95H0.95V15V17V17.05H1H11H11.05V17V15V14.95H11H1ZM5.05 3V2.95H5H1H0.95V3V5V5.05H1H5H5.05V5V3ZM1 8.95H0.95V9V11V11.05H1H8H8.05V11V9V8.95H8H1Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 5.03583H15.9467V17.1129V17.1629H15.9967H18.0023H18.0523V17.1129V5.03583H21.0107H21.1314L21.0461 4.95047L17.0349 0.939254L16.9995 0.903899L16.9641 0.939254L12.9529 4.95047L12.8676 5.03583H12.9883Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.d245a9b893725a89143d9c02fa72f0b0.svg";
export { ForwardRef as ReactComponent };